import { IHeader } from '../models';

let headerVisibility = true;

export const setupHeader = (headerData: IHeader) => {
    const headerElement = document.getElementById('header');
    while (headerElement!.lastChild) {
        headerElement!.removeChild(headerElement!.lastChild!);
    }
    const headerAssetsCSSElement = document.getElementById('headerAssetsCSS');
    headerAssetsCSSElement!.setAttribute('href', headerData.headerAssets.css.uri);
    headerAssetsCSSElement!.setAttribute('integrity', headerData.headerAssets.css.integrity || '');

    let headerAssetsJSElement = document.getElementById('headerAssetsJS');
    headerAssetsJSElement?.remove();

    headerAssetsJSElement = document.createElement('script');
    headerAssetsJSElement.setAttribute('id', 'headerAssetsJS');
    headerAssetsJSElement.setAttribute('crossorigin', 'anonymous');
    headerAssetsJSElement.setAttribute('defer', 'true');
    headerAssetsJSElement.setAttribute('src', headerData.headerAssets.js.uri);
    headerAssetsJSElement.setAttribute('integrity', headerData.headerAssets.js.integrity || '');
    document.head.appendChild(headerAssetsJSElement);

    headerAssetsJSElement!.onload = () => {
        XERO.bus.on('header:ready', () => {
            headerElement!.removeAttribute('style');
            setVisible(headerVisibility);
        });
        XERO.Header.init(headerData.header, headerElement);
    };
};

export const setVisible = (visible: boolean = true) => {
    const headerElement = document.getElementById('header');
    headerVisibility = visible;
    if (visible) {
        if (headerElement) { headerElement.style.visibility = "visible" };
    } else {
        if (headerElement) { headerElement.style.visibility = "hidden" };
    }
}

export const removeHeader = () => {
    const headerElement = document.getElementById('header');
    if (headerElement && headerElement.parentNode) {
        headerElement.parentNode.removeChild(headerElement);
    }
};